import * as React from 'react'

import DialogContent        from '@material-ui/core/DialogContent/DialogContent'
import DialogTitle          from '@material-ui/core/DialogTitle/DialogTitle'
import { withFormik }       from 'formik'
import { FormattedMessage } from 'react-intl'

import { Experience }                            from '../../api'
import asDialog, { InjectedAsDialogProps }       from '../hocs/asDialog'
import SingleExperienceChunk                     from './chunks/SingleExperienceChunk'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import { emptyExperience, experienceSchema }     from './schemas'
import { FormikComponentProps }                  from './types'
import asNestedForm                              from './wrappers/asNestedForm'

const SingleExperienceForm = withFormik<FormikComponentProps<Experience>, Experience>({
  mapPropsToValues: genValueMapper(emptyExperience),
  validationSchema: experienceSchema,
  handleSubmit:     proxyFormikSubmission,
})(
  asNestedForm<Experience>(
    SingleExperienceChunk,
  ),
)

interface SingleExperienceFormProps {
  save: (values: Experience) => void
}

const SingleExperienceFormDialog = ({
  save,
  close,
  ...rest
}: InjectedAsDialogProps & SingleExperienceFormProps) => (
  <>
    <DialogTitle>
      <FormattedMessage id={'forms.experience'} />
    </DialogTitle>
    <DialogContent>
      <SingleExperienceForm
        {...rest}
        onSubmit={(values) => {
          save(values)
          close()
        }}
      />
    </DialogContent>
  </>
)

export default asDialog(SingleExperienceFormDialog)



// WEBPACK FOOTER //
// ./src/components/forms/SingleExperienceForm.tsx